/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        Hello: 'Hello',
        Hello2: 'Hello2',
        Pre: 'Pre',
        OrderTrans: 'OrderTrans',
        OrderMore: 'OrderMore',
        OrderDetail: 'OrderDetail',
        CartAmount: 'CartAmount', // ~개 에 사용됨
        BestBot: 'BestBot',
        BestMoreBot : 'BestMoreBot',
        BestMore: 'BestMore',
        NewBot: 'NewBot',
        NewMoreBot : 'NewMoreBot',
        NewMore: 'NewMore',
        AlarmRegist: 'AlarmRegist', // '재판매 알림 신청하기',
        DetailBot: 'DetailBot',// '찾으신 상품 정보에요',
        Buy: 'Buy',// '바로 구매하기',
        Detail: 'Detail',// '상품상세정보',
        CategoryBot: 'CategoryBot',// '어떤 {category} 상품을 보고 싶으세요?',
        CategoryReselect: 'CategoryReselect',// '이전 카테고리 재선택',
    },
    tomy:{
        kr: {
            Hello: '안녕하세요. {name}님!',
            Hello2: '안녕하세요. {name} {level}님!',    
            Pre: '이전 상품 보기',
            BestBot: '요즘 애터미인이 가장 많이 구매하는 상품입니다.', 
            BestMoreBot : '인기상품을 더 보여드릴게요.',
            BestMore: '인기상품 더보기',
            NewBot: '마침 신상품이 입고되었다고 합니다! 바로 보여드려요.',
            NewMoreBot : '신상품을 더 보여드리겠습니다.',
            NewMore: '신상품 더보기',
            CartAmount: '개',
            OrderDetail: '주문내역 자세히보기',
            OrderTrans: '배송 조회하기',
            OrderMore: '주문내역 더보기',    
            AlarmRegist: '재판매 알림 신청하기',        
            DetailBot: '찾으신 상품 정보에요',
            Buy: '바로 구매하기',
            Detail: '상품상세정보',
            CategoryBot: '{category}의 카테고리를 보여드리겠습니다.', //category == 대 카테고리
            CategoryReselect: '이전 카테고리 재선택',
        },
        eng: {
            Hello: 'Hello, {name}!',
            Hello2: 'Hello, {name} {level}!',    
            Pre: 'Previous',
            BestBot: 'These days, it is the most purchased product by Atomy man.', 
            BestMoreBot : 'We will show you additional popular products.',
            BestMore: 'See more popular products',
            NewBot: "It seems that a new product has just arrived! I'll show you right away.",
            NewMoreBot : "We'll show you additional new products.",
            NewMore: 'See additional new products',

            OrderDetail: 'View order details',
            OrderTrans: 'Track Shipping',
            OrderMore: 'View more orders',    
            CartAmount: 'EA',
            AlarmRegist: 'Sign up for resale notifications',        
            DetailBot: 'Here is the product information you found.',
            Buy: 'Buy Now',
            Detail: 'Product details',
            CategoryBot: 'We will show you the categories of {category}.', //category == 대 카테고리
            CategoryReselect: 'Category reselection',
        }
    },
    papa:{
        kr: {
            Hello: '안녕하세요. {name}님!',
            Hello2: '안녕하세요. {name} {level}님!',    
            Pre: '이전 상품 보기',
            BestBot: '애터미 쇼핑몰에서 제일 인기 있는 상품들이에요.', 
            BestMoreBot : '인기상품을 더 보여드릴게요.',
            BestMore: '인기상품 더보기',
            NewBot: '이번에도 괜찮은 상품들이 새로 들어왔네요. 왜 다들 애터미, 애터미 하는지 알 것 같아요~^^',
            NewMoreBot : '신상품이 더 준비되어 있어요.',
            NewMore: '신상품 더보기',
            CartAmount: '개',

            OrderDetail: '주문내역 자세히보기',
            OrderTrans: '배송 조회하기',
            OrderMore: '주문내역 더보기',    

            AlarmRegist: '재판매 알림 신청하기',        
            DetailBot: '찾으신 상품 정보에요',
            Buy: '바로 구매하기',
            Detail: '상품상세정보',
            CategoryBot: '오호, 조금 더 구체적으로 알려주세요.', //category == 대 카테고리
            CategoryReselect: '이전 카테고리 재선택',
        },
        eng: {
            Hello: 'Hello, {name}!',
            Hello2: 'Hello, {name} {level}!',    
            Pre: 'Previous',
            BestBot: 'These are the most popular products in Atomy Shopping Mall.', 
            BestMoreBot : 'We will show you additional popular products.',
            BestMore: 'See additional popular products',
            NewBot: 'Some great products have arrived! Now I know why everyone likes Atomy.',
            NewMoreBot : 'Additional new products are available.',
            NewMore: 'See additional new products',
            CartAmount: 'EA',

            OrderDetail: 'View order details',
            OrderTrans: 'Track Shipping',
            OrderMore: 'View more orders',    
            
            AlarmRegist: 'Sign up for resale notifications',        
            DetailBot: 'Here is the product information you found.',
            Buy: 'Buy Now',
            Detail: 'Product details',
            CategoryBot: 'Oh, please be a little more specific.', //category == 대 카테고리
            CategoryReselect: 'Category reselection',
        }
    },
};
